export const BEGIN_LOGIN = "BEGIN_LOGIN";
export const LOGIN_REJECTED = "LOGIN_REJECTED";
export const LOGIN_FULFILLED = "LOGIN_FULFILLED";
export const AUTH_LOGOUT_STARTED = "AUTH_LOGOUT_STARTED";
export const AUTH_LOGOUT_REJECTED = "AUTH_LOGOUT_REJECTED";
export const AUTH_LOGOUT_FULFILLED = "AUTH_LOGOUT_FULFILLED";
export const NOT_AUTHENTICATED = "NOT_AUTHENTICATED";

export const GET_POSTS_STARTED = "GET_POSTS_STARTED";
export const GET_POSTS_REJECTED = "GET_POSTS_REJECTED";
export const GET_POSTS_FULFILLED = "GET_POSTS_FULFILLED";

export const ACTIVITIES_GET_STARTED = "ACTIVITIES_GET_STARTED";
export const ACTIVITIES_GET_REJECTED = "ACTIVITIES_GET_REJECTED";
export const ACTIVITIES_GET_FULFILLED = "ACTIVITIES_GET_FULFILLED";

export const ASSOCIATIONS_GET_MANAGEABLE_STARTED =
  "ASSOCIATIONS:GET_MANAGEABLE_STARTED";
export const ASSOCIATIONS_GET_MANAGEABLE_REJECTED =
  "ASSOCIATIONS:GET_MANAGEABLE_REJECTED";
export const ASSOCIATIONS_GET_MANAGEABLE_FULFILLED =
  "ASSOCIATIONS:GET_MANAGEABLE_FULFILLED";

export const ASSOCIATIONS_GET_MY_FULFILLED = "ASSOCIATIONS_GET_MY_FULFILLED";

export const ASSOCIATIONS_GET_RESOURCES_FULFILLED =
  "ASSOCIATIONS_GET_RESOURCES_FULFILLED";

export const ASSOCIATIONS_UPDATE_FULFILLED = "ASSOCIATIONS_UPDATE_FULFILLED";

export const ASSOCIATIONS_UPDATE_CONFIG_STARTED = "ASSOCIATIONS_UPDATE_CONFIG_STARTED";
export const ASSOCIATIONS_UPDATE_CONFIG_REJECTED = "ASSOCIATIONS_UPDATE_CONFIG_REJECTED";
export const ASSOCIATIONS_UPDATE_CONFIG_FULFILLED = "ASSOCIATIONS_UPDATE_CONFIG_FULFILLED";

export const PERSONS_GET_SELF_STARTED = "PERSONS:GET_SELF_STARTED";
export const PERSONS_GET_SELF_REJECTED = "PERSONS:GET_SELF_REJECTED";
export const PERSONS_GET_SELF_FULFILLED = "PERSONS:GET_SELF_FULFILLED";

export const PERSONS_GET_PERSONS_BY_IDS_STARTED =
  "PERSONS_GET_PERSONS_BY_IDS_STARTED";
export const PERSONS_GET_PERSONS_BY_IDS_REJECTED =
  "PERSONS_GET_PERSONS_BY_IDS_REJECTED";
export const PERSONS_GET_PERSONS_BY_IDS_FULFILLED =
  "PERSONS_GET_PERSONS_BY_IDS_FULFILLED";

export const PERSONS_GET_FULL_PERSON_BY_ID_STARTED =
  "PERSONS_GET_FULL_PERSON_BY_ID_STARTED";
export const PERSONS_GET_FULL_PERSON_BY_ID_REJECTED =
  "PERSONS_GET_FULL_PERSON_BY_ID_REJECTED";
export const PERSONS_GET_FULL_PERSON_BY_ID_FULFILLED =
  "PERSONS_GET_FULL_PERSON_BY_ID_FULFILLED";

export const PERSONS_GET_PERSONS_BY_ASSOCIATION_STARTED =
  "PERSONS_GET_PERSONS_BY_ASSOCIATION_STARTED";
export const PERSONS_GET_PERSONS_BY_ASSOCIATION_FULFILLED =
  "PERSONS_GET_PERSONS_BY_ASSOCIATION_FULFILLED";
export const PERSONS_GET_PERSONS_BY_ASSOCIATION_REJECTED =
  "PERSONS_GET_PERSONS_BY_ASSOCIATION_REJECTED";

export const PERSONS_GET_MANAGEABLE_REJECTED =
  "PERSONS_GET_MANAGEABLE_REJECTED";
export const PERSONS_GET_MANAGEABLE_STARTED = "PERSONS_GET_MANAGEABLE_STARTED";
export const PERSONS_GET_MANAGEABLE_FULFILLED =
  "PERSONS_GET_MANAGEABLE_FULFILLED";

export const PERSONS_SAVE_PERSON_STARTED = "PERSONS_SAVE_PERSON_STARTED";
export const PERSONS_SAVE_PERSON_FULFILLED = "PERSONS_SAVE_PERSON_FULFILLED";
export const PERSONS_SAVE_PERSON_REJECTED = "PERSONS_SAVE_PERSON_REJECTED";
export const PERSONS_CREATE_PERSON_FULFILLED =
  "PERSONS_CREATE_PERSON_FULFILLED";

export const PERSONS_GET_BY_USERNAME_STARTED =
  "PERSONS_GET_BY_USERNAME_STARTED";
export const PERSONS_GET_BY_USERNAME_FULFILLED =
  "PERSONS_GET_BY_USERNAME_FULFILLED";
export const PERSONS_GET_BY_USERNAME_REJECTED =
  "PERSONS_GET_BY_USERNAME_REJECTED";

export const GAME_REMOVE_ERRORS = "GAME_REMOVE_ERRORS";

export const SHIFTS_GET_SUPERVISABLE_STARTED =
  "SHIFTS_GET_SUPERVISABLE_STARTED";
export const SHIFTS_GET_SUPERVISABLE_REJECTED =
  "SHIFTS_GET_SUPERVISABLE_REJECTED";
export const SHIFTS_GET_SUPERVISABLE_FULFILLED =
  "SHIFTS_GET_SUPERVISABLE_FULFILLED";

export const SHIFTS_GET_SHIFT_STARTED = "SHIFTS_GET_SHIFT_STARTED";
export const SHIFTS_GET_SHIFT_REJECTED = "SHIFTS_GET_SHIFT_REJECTED";
export const SHIFTS_GET_SHIFT_FULFILLED = "SHIFTS_GET_SHIFT_FULFILLED";

export const SHIFTS_GET_MANAGEABLE_STARTED = "SHIFTS_GET_MANAGEABLE_STARTED";
export const SHIFTS_GET_MANAGEABLE_FULFILLED =
  "SHIFTS_GET_MANAGEABLE_FULFILLED";
export const SHIFTS_GET_MANAGEABLE_REJECTED = "SHIFTS_GET_MANAGEABLE_REJECTED";

export const SHIFT_ROSTER_GAME_STARTED = "SHIFT_ROSTER_GAME_STARTED";
export const SHIFT_ROSTER_GAME_FULFILLED = "SHIFT_ROSTER_GAME_FULFILLED";
export const SHIFT_ROSTER_GAME_REJECTED = "SHIFT_ROSTER_GAME_REJECTED";

export const SHIFTS_CREATE_SHIFT_STARTED = "SHIFTS_CREATE_SHIFT_STARTED";
export const SHIFTS_CREATE_SHIFT_FULFILLED = "SHIFTS_CREATE_SHIFT_FULFILLED";
export const SHIFTS_CREATE_SHIFT_REJECTED = "SHIFTS_CREATE_SHIFT_REJECTED";

export const SHIFTS_UPDATE_SHIFT_STARTED = "SHIFTS_UPDATE_SHIFT_STARTED";
export const SHIFTS_UPDATE_SHIFT_FULFILLED = "SHIFTS_UPDATE_SHIFT_FULFILLED";
export const SHIFTS_UPDATE_SHIFT_REJECTED = "SHIFTS_UPDATE_SHIFT_REJECTED";

export const SHIFTS_ROSTER_SUPERVISOR_STARTED =
  "SHIFTS_ROSTER_SUPERVISOR_STARTED";
export const SHIFTS_ROSTER_SUPERVISOR_FULFILLED =
  "SHIFTS_ROSTER_SUPERVISOR_FULFILLED";
export const SHIFTS_ROSTER_SUPERVISOR_REJECTED =
  "SHIFTS_ROSTER_SUPERVISOR_REJECTED";

export const SHIFTS_REMOVE_SUPERVISOR_STARTED =
  "SHIFTS_REMOVE_SUPERVISOR_STARTED";
export const SHIFTS_REMOVE_SUPERVISOR_FULFILLED =
  "SHIFTS_REMOVE_SUPERVISOR_FULFILLED";
export const SHIFTS_REMOVE_SUPERVISOR_REJECTED =
  "SHIFTS_REMOVE_SUPERVISOR_REJECTED";

export const SHIFTS_ROSTER_ADMIN_STARTED = "SHIFTS_ROSTER_ADMIN_STARTED"
export const SHIFTS_ROSTER_ADMIN_FULFILLED = "SHIFTS_ROSTER_ADMIN_FULFILLED"
export const SHIFTS_ROSTER_ADMIN_REJECTED = "SHIFTS_ROSTER_ADMIN_REJECTED"

export const SHIFTS_REMOVE_ADMIN_STARTED =
  "SHIFTS_REMOVE_ADMIN_STARTED";
export const SHIFTS_REMOVE_ADMIN_FULFILLED =
  "SHIFTS_REMOVE_ADMIN_FULFILLED";
export const SHIFTS_REMOVE_ADMIN_REJECTED =
  "SHIFTS_REMOVE_ADMIN_REJECTED";

export const SHIFTS_PUBLISH_SESSION_STARTED = "SHIFTS_PUBLISH_SESSION_STARTED";
export const SHIFTS_PUBLISH_SESSION_FULFILLED =
  "SHIFTS_PUBLISH_SESSION_FULFILLED";
export const SHIFTS_PUBLISH_SESSION_REJECTED =
  "SHIFTS_PUBLISH_SESSION_REJECTED";

export const SHIFTS_UPDATE_ENROLMENT_FULFILLED =
  "SHIFTS_UPDATE_ENROLMENT_FULFILLED";
export const SHIFTS_REMOVE_ENROLMENT_FULFILLED =
  "SHIFTS_REMOVE_ENROLMENT_FULFILLED";
export const SHIFTS_ADD_ENROLMENT_FULFILLED = "SHIFTS_ADD_ENROLMENT_FULFILLED";
export const SHIFTS_UPDATE_SESSION_FULFILLED =
  "SHIFTS_UPDATE_SESSION_FULFILLED";
export const SHIFTS_REMOVE_SESSION_FULFILLED =
  "SHIFTS_REMOVE_SESSION_FULFILLED";
export const SHIFTS_ADD_SESSION_FULFILLED = "SHIFTS_ADD_SESSION_FULFILLED";

export const IMPORT_UPLOAD_STARTED = "IMPORT_UPLOAD_STARTED";
export const IMPORT_UPLOAD_PROGRESS = "IMPORT_UPLOAD_PROGRESS";
export const IMPORT_UPLOAD_FULFILLED = "IMPORT_UPLOAD_FULFILLED";
export const IMPORT_UPLOAD_REJECTED = "IMPORT_UPLOAD_REJECTED";

export const IMPORT_TRIGGER_STARTED = "IMPORT_TRIGGER_STARTED";
export const IMPORT_TRIGGER_FULFILLED = "IMPORT_TRIGGER_FULFILLED";
export const IMPORT_TRIGGER_REJECTED = "IMPORT_TRIGGER_REJECTED";

export const IMPORT_GET_MY_STARTED = "IMPORT_GET_MY_STARTED";
export const IMPORT_GET_MY_FULFILLED = "IMPORT_GET_MY_FULFILLED";
export const IMPORT_GET_MY_REJECTED = "IMPORT_GET_MY_REJECTED";

export const IMPORT_GET_STARTED = "IMPORT_GET_STARTED";
export const IMPORT_GET_FULFILLED = "IMPORT_GET_FULFILLED";
export const IMPORT_GET_REJECTED = "IMPORT_GET_REJECTED";

export const TOKEN_GET_STARTED = "TOKEN_GET_STARTED";
export const TOKEN_GET_FULFILLED = "TOKEN_GET_FULFILLED";
export const TOKEN_GET_REJECTED = "TOKEN_GET_REJECTED";

export const VENUES_GET_ALL_STARTED = "VENUES_GET_ALL_STARTED";
export const VENUES_GET_ALL_FULFILLED = "VENUES_GET_ALL_FULFILLED";
export const VENUES_GET_ALL_REJECTED = "VENUES_GET_ALL_REJECTED";

export const TEAMS_GET_ALL_STARTED = "TEAMS_GET_ALL_STARTED";
export const TEAMS_GET_ALL_FULFILLED = "TEAMS_GET_ALL_FULFILLED";
export const TEAMS_GET_ALL_REJECTED = "TEAMS_GET_ALL_REJECTED";

export const COMPETITIONS_GET_ALL_STARTED = "COMPETITIONS_GET_ALL_STARTED";
export const COMPETITIONS_GET_ALL_FULFILLED = "COMPETITIONS_GET_ALL_FULFILLED";
export const COMPETITIONS_GET_ALL_REJECTED = "COMPETITIONS_GET_ALL_REJECTED";

export const GAMES_UPDATE_STARTED = "GAMES_UPDATE_STARTED";
export const GAMES_UPDATE_FULFILLED = "GAMES_UPDATE_FULFILLED";
export const GAMES_UPDATE_REJECTED = "GAMES_UPDATE_REJECTED";

export const GAMES_ADDED_EXTRA_OFFICIAL_FULLFILLED =
  "GAMES_ADDED_EXTRA_OFFICIAL_FULLFILLED";
export const GAMES_ADDED_EXTRA_OFFICIAL_STARTED =
  "GAMES_ADDED_EXTRA_OFFICIAL_STARTED";
export const GAMES_ADDED_EXTRA_OFFICIAL_REJECTED =
  "GAMES_ADDED_EXTRA_OFFICIAL_REJECTED";

export const GAMES_REMOVE_EXTRA_OFFICIAL_STARTED =
  "GAMES_REMOVE_EXTRA_OFFICIAL_STARTED";
export const GAMES_REMOVE_EXTRA_OFFICIAL_REJECTED =
  "GAMES_REMOVE_EXTRA_OFFICIAL_REJECTED";
export const GAMES_REMOVE_EXTRA_OFFICIAL_FULLFILLED =
  "GAMES_REMOVE_EXTRA_OFFICIAL_FULLFILLED";

export const APPOINTMENTS_UPDATE_STATUS_STARTED =
  "APPOINTMENTS_UPDATE_STATUS_STARTED";
export const APPOINTMENTS_UPDATE_FULFILLED = "APPOINTMENTS_UPDATE_FULFILLED";
export const APPOINTMENTS_UPDATE_STATUS_REJECTED =
  "APPOINTMENTS_UPDATE_STATUS_REJECTED";

export const APPOINTMENTS_ADD_LOADING_STARTED =
  "APPOINTMENTS_ADD_LOADING_STARTED";
export const APPOINTMENTS_ADD_LOADING_REJECTED =
  "APPOINTMENTS_ADD_LOADING_REJECTED";
export const APPOINTMENTS_ADD_LOADING_FULFILLED =
  "APPOINTMENTS_ADD_LOADING_FULFILLED";

export const APPOINTMENTS_GET_PUBLISHED_STARTED =
  "APPOINTMENTS_GET_PUBLISHED_STARTED";
export const APPOINTMENTS_GET_PUBLISHED_REJECTED =
  "APPOINTMENTS_GET_PUBLISHED_REJECTED";
export const APPOINTMENTS_GET_PUBLISHED_FULFILLED =
  "APPOINTMENTS_GET_PUBLISHED_FULFILLED";

export const APPOINTMENTS_GET_BY_PERSON_FULFILLED =
  "APPOINTMENTS_GET_BY_PERSON_FULFILLED";

export const APPOINTMENTS_GET_ACTIONABLE_FULFILLED =
  "APPOINTMENTS_GET_ACTIONABLE_FULFILLED";

export const PAYRATES_GET_BY_ID_STARTED = "PAYRATES_GET_BY_ID_STARTED";
export const PAYRATES_GET_BY_ID_FULFILLED = "PAYRATES_GET_BY_ID_FULFILLED";
export const PAYRATES_GET_BY_ID_REJECTED = "PAYRATES_GET_BY_ID_REJECTED";

export const PAYRATES_GET_ALL_STARTED = "PAYRATES_GET_ALL_STARTED";
export const PAYRATES_GET_ALL_FULFILLED = "PAYRATES_GET_ALL_FULFILLED";
export const PAYRATES_GET_ALL_REJECTED = "PAYRATES_GET_ALL_REJECTED";

// Association payrate CRUD actions
export const PAYRATES_CREATE_ASSOCIATION_STARTED = "PAYRATES_CREATE_ASSOCIATION_STARTED";
export const PAYRATES_CREATE_ASSOCIATION_FULFILLED = "PAYRATES_CREATE_ASSOCIATION_FULFILLED";
export const PAYRATES_CREATE_ASSOCIATION_REJECTED = "PAYRATES_CREATE_ASSOCIATION_REJECTED";

export const PAYRATES_UPDATE_ASSOCIATION_STARTED = "PAYRATES_UPDATE_ASSOCIATION_STARTED";
export const PAYRATES_UPDATE_ASSOCIATION_FULFILLED = "PAYRATES_UPDATE_ASSOCIATION_FULFILLED";
export const PAYRATES_UPDATE_ASSOCIATION_REJECTED = "PAYRATES_UPDATE_ASSOCIATION_REJECTED";

export const PAYRATES_DELETE_ASSOCIATION_STARTED = "PAYRATES_DELETE_ASSOCIATION_STARTED";
export const PAYRATES_DELETE_ASSOCIATION_FULFILLED = "PAYRATES_DELETE_ASSOCIATION_FULFILLED";
export const PAYRATES_DELETE_ASSOCIATION_REJECTED = "PAYRATES_DELETE_ASSOCIATION_REJECTED";

export const PAYRATES_GET_ASSOCIATION_STARTED = "PAYRATES_GET_ASSOCIATION_STARTED";
export const PAYRATES_GET_ASSOCIATION_FULFILLED = "PAYRATES_GET_ASSOCIATION_FULFILLED";
export const PAYRATES_GET_ASSOCIATION_REJECTED = "PAYRATES_GET_ASSOCIATION_REJECTED";

export const PAYRATES_CLONE_STARTED = "PAYRATES_CLONE_STARTED";
export const PAYRATES_CLONE_FULFILLED = "PAYRATES_CLONE_FULFILLED";
export const PAYRATES_CLONE_REJECTED = "PAYRATES_CLONE_REJECTED";

// Association payrate attachment actions
export const PAYRATES_ATTACH_STARTED = "PAYRATES_ATTACH_STARTED";
export const PAYRATES_ATTACH_FULFILLED = "PAYRATES_ATTACH_FULFILLED";
export const PAYRATES_ATTACH_REJECTED = "PAYRATES_ATTACH_REJECTED";

export const PAYRATES_DETACH_STARTED = "PAYRATES_DETACH_STARTED";
export const PAYRATES_DETACH_FULFILLED = "PAYRATES_DETACH_FULFILLED";
export const PAYRATES_DETACH_REJECTED = "PAYRATES_DETACH_REJECTED";

export const AVAILABILITIES_GET_MY_STARTED = "AVAILABILITIES_GET_MY_STARTED";
export const AVAILABILITIES_GET_MY_FULFILLED =
  "AVAILABILITIES_GET_MY_FULFILLED";
export const AVAILABILITIES_GET_MY_REJECTED = "AVAILABILITIES_GET_MY_REJECTED";

export const AVAILABILITIES_GET_FULFILLED = "AVAILABILITIES_GET_FULFILLED";

export const AVAILABILITIES_CREATE_FULFILLED =
  "AVAILABILITIES_CREATE_FULFILLED";
export const AVAILABILITIES_DELETE_FULFILLED =
  "AVAILABILITIES_DELETE_FULFILLED";

export const TOGGLE_DARK = "TOGGLE_DARK";

export const BEGIN_AJAX_CALL = "BEGIN_AJAX_CALL";

// Admin Communications
export const ADMIN_COMMUNICATIONS_FETCH_STARTED = "ADMIN_COMMUNICATIONS_FETCH_STARTED";
export const ADMIN_COMMUNICATIONS_FETCH_FULFILLED = "ADMIN_COMMUNICATIONS_FETCH_FULFILLED";
export const ADMIN_COMMUNICATIONS_FETCH_REJECTED = "ADMIN_COMMUNICATIONS_FETCH_REJECTED";

export const ADMIN_COMMUNICATIONS_SELECT = "ADMIN_COMMUNICATIONS_SELECT";
export const ADMIN_COMMUNICATIONS_SET_FILTERS = "ADMIN_COMMUNICATIONS_SET_FILTERS";
export const ADMIN_COMMUNICATIONS_CLEAR_FILTERS = "ADMIN_COMMUNICATIONS_CLEAR_FILTERS";
